import { useAppScopeStore } from '@frontend/scope';
import { useAppFlagStore } from '@frontend/shared';

export const useWeaveRewindFeatureFlag = () => {
  const { selectedLocationIds: locationIds } = useAppScopeStore();
  const { getFeatureFlagValue } = useAppFlagStore();

  return getFeatureFlagValue({
    locationIds,
    flagName: 'threads-of-success',
    strategy: 'ALL',
  });
};
